import MacroOperations from "common/datasources/macros/MacroOperations";
import locale from "common/managers/locale";

export default {

    _cache: [],
    /**
     * Validate a macro string.  Returns true or false right away.  False only if the validation state of the given macro is already known.
     * True if state is not known, and the redo will be called once the state is known.  True if state is known and macro is valid.
     * @param str
     * @param redo
     */
    validate: function(str, paramType, redo) {
        for (var i = 0; i < this._cache.length; i++) {
            if (this._cache[i].str == str) {
                return this._cache[i].good;
            }
        }

        var me = this;
        var result = function(good, message) {
            if (me._cache.length > 10) {
                me._cache.pop();
            }
            me._cache.push({
                str: str,
                good: good,
                message: message
            });
            redo();
        };

        MacroOperations.validate(str, paramType)
            .done(function() {
                result(true);
            })
            .handle("error/message", function(err) {
                result(false, err.get("message"));
            })
            .handle("error/server", function(err) {
                result(false, err.get("message"));
            });
        return true;
    },
    message: function(str) {
        for (var i = 0; i < this._cache.length; i++) {
            if (this._cache[i].str == str && this._cache[i].message) {
                return this._cache[i].message;
            }
        }
        return locale.get("macro.invalid");
    }
}
